import {
    Injectable
} from '@angular/core';
import {
    WebView
} from '@ionic-native/ionic-webview/ngx';
import {
    Device
} from '@ionic-native/device/ngx';
import {
    SplashScreen
} from '@ionic-native/splash-screen/ngx';
import {
    StatusBar
} from '@ionic-native/status-bar/ngx';
import {
    Keyboard
} from '@ionic-native/keyboard/ngx';
import {
    Network
} from '@ionic-native/network/ngx';
import {
    BarcodeScanner
} from '@ionic-native/barcode-scanner/ngx';
import {
    SecureStorage,
    SecureStorageObject
} from '@ionic-native/secure-storage/ngx';
import {
    File
} from '@ionic-native/file/ngx';
@Injectable()
export class ApperyioNativeHelperService {
    public audioinput;
    constructor(
        public webView: WebView, public device: Device, public splashScreen: SplashScreen, public statusBar: StatusBar, public keyboard: Keyboard, public network: Network, public barcodeScanner: BarcodeScanner, public secureStorage: SecureStorage, public file: File
    ) {
        this.audioinput = (window as any).audioinput;
    }
};